import React from "react";
import Helmet from "react-helmet";
import Header from "./header"
import Footer from "./footer"
import {Link} from "react-router-dom"
function Contact(){
    return (
        <div>
        <Header/>
      <section className="page-title centred" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1527964275784-5ce8ddab3d8e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDV8fGV0aGlvcGlhfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60)'}}>
  <div className="auto-container">
    <div className="content-box">
      <div className="title">
        <h1>Contact Us</h1>
      </div>
      <ul className="bread-crumb clearfix">
        <li>
            <Link to="/">Home</Link>
        </li>
        
      </ul>
    </div>
  </div>
</section>

<section className="contact-info-section">
  <div className="auto-container">
    <div className="row clearfix">
      <div className="col-lg-4 col-md-6 col-sm-12 info-column">
        <div className="single-info-box">
          <div className="inner-box">
            <div className="icon-box"><i className="flaticon-email" /></div>
            <p><Link to="#">enku@gmail.com</Link><br /></p>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-12 info-column">
        <div className="single-info-box">
          <div className="inner-box">
            <div className="icon-box"><i className="flaticon-telephone" /></div>
            <p><Link to="#">09111213145</Link><br /><Link to="tel:#">09121415645</Link></p>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-12 info-column">
        <div className="single-info-box">
          <div className="inner-box">
            <div className="icon-box"><i className="flaticon-pin" /></div>
            <p>bole around megablock<br />Addis Abeba, Ethiopia</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="contact-section sec-pad">
  <div className="auto-container">
    <div className="row clearfix">
      <div className="col-lg-6 col-md-12 col-sm-12 title-column">
        <div className="title-inner">
          <div className="sec-title">
            <p>Contact with Us</p>
            <h2>Call Now or Write a Message</h2>
          </div>
          <div className="text">
            <p>Lorem ipsum dolor sit amet, conse ctetur adipisicing elit sed do eiusm od tempor ut labore. sit amet scelerisque eros. Phasellus hendrerit neque a augue.</p>
          </div>
          <ul className="social-links clearfix"> 
            <li><h6>Connect:</h6></li>
            <li><Link to="#"><span className="fab fa-twitter" /></Link></li>
          <li><Link to="#"><span className="fab fa-twitter" /></Link></li>
          <li><Link to="#"><span className="fab fa-twitter" /></Link></li>
          <li><Link to="#"><span className="fab fa-twitter" /></Link></li>
          <li><Link to="#"><span className="fab fa-twitter" /></Link></li> </ul>
        </div>
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12 form-column">
        <div className="form-inner">
       <div className="service-sidebar">
  <div className="category-widget">
    
  </div>
  <div className="support-box">
    <figure className="image-box"></figure>
    <div className="content-box">
      <div className="icon-box"><i className="flaticon-phone" /></div>
      <p>Get Professional Help</p>
      <h3><Link to="#">09111213145</Link></h3>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  </div>
</section>




        <Footer/>


<Helmet>
<script src="assets/js/jquery.js"></script>
    <script src="assets/js/popper.min.js"></script>
    <script src="assets/js/bootstrap.min.js"></script>
    <script src="assets/js/owl.js"></script>
    <script src="assets/js/wow.js"></script>
    <script src="assets/js/validation.js"></script>
    <script src="assets/js/jquery.fancybox.js"></script>
    <script src="assets/js/appear.js"></script>
    <script src="assets/js/scrollbar.js"></script>
    <script src="assets/js/isotope.js"></script>
    <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyA-CE0deH3Jhj6GN4YvdCFZS7DpbXexzGU"></script>
    <script src="assets/js/gmaps.js"></script>
    <script src="assets/js/map-helper.js"></script>
    <script src="assets/js/script.js"></script>
</Helmet>
        </div>
    )
}
export default Contact;